import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

const BASE_URL = process.env.REACT_APP_API_URL + "/api/import/import-prices";

// Get current price list with import items
export const getCurrentPriceList = async () => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/current-list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Current Price List Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching current price list:", error);
        return "Something went wrong...";
      });
  }
};

// Get price history for an import item
export const getPriceHistory = async (importId) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/history/${importId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Price History Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching price history:", error);
        return "Something went wrong...";
      });
  }
};

// Get current price for an import item
export const getCurrentPrice = async (importId) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/current/${importId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Current Price Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching current price:", error);
        return "Something went wrong...";
      });
  }
};

// Get price statistics for an import item
export const getPriceStatistics = async (importId) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/statistics/${importId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Price Statistics Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching price statistics:", error);
        return "Something went wrong...";
      });
  }
};

// Get price trend for an import item
export const getPriceTrend = async (importId) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/trend/${importId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Price Trend Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching price trend:", error);
        return "Something went wrong...";
      });
  }
};

// Create manual price record
export const createManualPrice = async (priceData) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    // get user name
    let user = getUser();

    // Add username to priceData if not already present
    const requestBody = {
      ...priceData,
      updatedBy: priceData.updatedBy || user.username,
    };

    return axios
      .post(`${BASE_URL}/manual`, requestBody, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Manual Price Created:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error creating manual price:", error);
        const apiError = error?.response?.data;
        const msg = apiError?.error || error.message || "Something went wrong";
        throw new Error(msg);
      });
  }
};

// Add new price (generic for all price types)
export const addNewPrice = async (priceBody) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    // get user name
    let user = getUser();

    // Add username to priceBody if not already present
    const requestBody = {
      ...priceBody,
      updatedBy: priceBody.updatedBy || user.username,
    };

    return axios
      .post(`${BASE_URL}`, requestBody, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Price Created:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error adding new price:", error);
        const apiError = error?.response?.data;
        const msg = apiError?.error || error.message || "Something went wrong";
        throw new Error(msg);
      });
  }
};

// Delete price record
export const deletePriceRecord = async (priceId) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .delete(`${BASE_URL}/${priceId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Price Deleted:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error deleting price record:", error);
        const apiError = error?.response?.data;
        const msg = apiError?.error || error.message || "Something went wrong";
        return msg;
      });
  }
};

// Get price history for last 6 months (if you want a separate endpoint)
export const getPriceHistoryLast6Months = async (importId) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/history/${importId}/last-6-months`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Price History (6 months) Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching price history (6 months):", error);
        return "Something went wrong...";
      });
  }
};

// Get prices by type
export const getPricesByType = async (importId, priceType) => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .get(`${BASE_URL}/by-type/${importId}/${priceType}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log("Prices by Type Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching prices by type:", error);
        return "Something went wrong...";
      });
  }
};

// Cleanup old price records (admin function)
export const cleanupOldPriceRecords = async () => {
  // check access token expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        `${BASE_URL}/cleanup`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log("Cleanup Response:", response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Error cleaning up old records:", error);
        return "Something went wrong...";
      });
  }
};

export default {
  getCurrentPriceList,
  getPriceHistory,
  getCurrentPrice,
  getPriceStatistics,
  getPriceTrend,
  createManualPrice,
  addNewPrice,
  deletePriceRecord,
  getPriceHistoryLast6Months,
  getPricesByType,
  cleanupOldPriceRecords,
};
